export const adminPermissions = {
  "/dashboard": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  Setup: {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "Access Management": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "/manage-parameters": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "/manage-statuses": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "/user-profile": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "/user-management": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "/permission": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
};

export const clientPermissions = {
  "/dashboard": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  Setup: {
    view: 0,
    status: 0,
    new: 0,
    edit: 0,
    remove: 0,
  },
  "Access Management": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "/manage-parameters": {
    view: 0,
    status: 0,
    new: 0,
    edit: 0,
    remove: 0,
  },
  "/manage-statuses": {
    view: 0,
    status: 0,
    new: 0,
    edit: 0,
    remove: 0,
  },
  "/user-profile": {
    view: 1,
    status: 1,
    new: 1,
    edit: 1,
    remove: 1,
  },
  "/user-management": {
    view: 0,
    status: 0,
    new: 0,
    edit: 0,
    remove: 0,
  },
  "/permission": {
    view: 0,
    status: 0,
    new: 0,
    edit: 0,
    remove: 0,
  },
};